module.exports = BMap;


//////////////////
// WEBPACK FOOTER
// external "BMap"
// module id = 1320
// module chunks = 